  <template>
  <div>
    <div class="top-bar flex justify-end">
      <v-button
        @click="() => { showFormImportEntities = true }"
        icon="file-import"
        class="mr-4"
        :disabled="showFormData"
      >{{ $t('import_purchases') }}</v-button>

      <v-button
        @click="openPurchaseModal(null)"
        icon="shopping-bag"
        :disabled="showFormData"
      >{{ $t('add_purchase') }}</v-button>

      <purchase-edit
        ref="purchase_modal"
        :projectId="projectId"
        :products="products"
        :providers="providers"

        @reload-list="handleSuccess"
      />
    </div>

    <div>
      <filters ref="filtersRef"
        :projectId="projectId"
        :visibleFilters="filtersVisible"
        :products="products"
        :providers="providers"
        entityType="store-purchases"
        @filters-updated="filtersUpdated"
      />
    </div>

    <inventory-dashboard ref="dashboardInventoryRef"
      :infoTitle="$t('inputs') + ' (' + $t('purchases') + ')'"
      :infoTotales="infoTotales"
      :projectId="projectId" />

    <div class="flex">
      <div :class="[showFormImportEntities ? 'w-7/12' : 'w-full', 'mr-2']">
        <purchases ref="purchases_list"
          :projectId="projectId"
          @epc-edit="handleEditEntity"
          @epc-totales-fetched="(totales) => { infoTotales = totales }"
        />
      </div>

      <transition name="fade">
        <div class="w-5/12 ml-2" v-if="showFormImportEntities">
          <purchases-import
            :projectId="projectId"
            :entity-type="'store-purchases'"
            @epc-close="(event) => { showFormImportEntities = false }"
            @epc-success-import="() => { showFormImportEntities = false ; $refs.purchases_list.reload() }"
          />
        </div>

      </transition>
    </div>
  </div>
</template>

<script>
import Purchases from './purchases.vue';
import PurchaseEdit from './purchase-modal.vue';
import PurchasesImport from './purchases-import.vue';
import Filters from './storehouse-filters.vue'
import InventoryDashboard from './inventory-dashboard.vue'
import axios from 'axios';

export default {
  name: "manage-invnetory",

  components: {
    Purchases,
    PurchaseEdit,
    PurchasesImport,
    Filters,
    InventoryDashboard
  },

  data: () => ({
    material: null, // objeto que se crea
    showFormData: false,
    showFormImportEntities: false,
    showFormLink: false,
    warehouses:[],
    infoTotales: {
      'total_qty': 0,
      'total_price': 0,
    },
    filtersVisible: {
      dates: {
        label: 'select_period',
        placeholder: 'select_period',
        visible: true,
        range: true
      },
      activities: {
        visible: false
      },
      purposes: {
        visible: false
      },
      deliveryNote: {
        visible: true
      },
      typeProduct: {
        visible: false
      },
      mainDiameter: {
        visible: false
      },
      stockMin: {
        visible: false
      },
      users: {
        visible: true
      }
    }
  }),

  props: {
    projectId: { type: Number, required: true },
    products: { type: Array, default: () => ([]) },
    providers: { type: Array, default: () => ([]) },
  },

  created() {
    this.getWarehouses();
  },

  mounted() {
  },

  methods: {

    // handleOnCloseEdit(event) {
    //   this.showFormData = !event
    // },

    handleSuccess() { // recibe la entidad editada
      let generatedFilters = this.customizeFilters();
      generatedFilters.page = 1;
      this.$refs.purchases_list.reload(generatedFilters)
      this.$emit('epc-updated-list')
    },

    handleEditEntity(entity) {
      this.openPurchaseModal(entity)
    },

    // Botones de acción
    openPurchaseModal(entity) {
      let purchase = {
        id: 0,
        product_id: null,
        provider_id: null,
        date_purchase: null, //new Date(),
        qty: 0,
        unit_price: 0.00,
        price: 0.00,
        delivery_note: "",
      };

      if(entity != null)
      {
        purchase.id = entity.id
        purchase.product_id = entity.inventory.product_id
        purchase.provider_id = entity.inventory.provider_id
        purchase.date_purchase = entity.date_purchase
        purchase.qty = entity.qty
        purchase.unit_price = entity.unit_price
        purchase.price = entity.price
        purchase.delivery_note = entity.delivery_note
      }

      this.$refs.purchase_modal.show(purchase, this.warehouses);
    },

    filtersUpdated() {
      this.applyFilters(1);
    },

    applyFilters(page) {
      let generatedFilters = this.customizeFilters();
      generatedFilters.page = 1;

      this.$refs.purchases_list.reload(generatedFilters)
    },

    customizeFilters() {
      let filters = this.$refs.filtersRef.generateFilters();
      return filters;
    },
    async getWarehouses() {
        try {
            const { data } = await axios.get(`/api/v2/project/${this.projectId}/warehouses`);
            if (data && data.success) {
                this.warehouses = data.warehouses;
            }
        } catch (error) {
            throw ('Error fetching warehouse:', error);
        }
    },
  }

};
</script>

<style scoped>

</style>
